import Delegate from "//legramme.com/cdn/shop/t/78/assets/ftdomdelegate.min.js?v=167457923630348017651773307050";

export class AvailablityDate extends HTMLSpanElement {
  connectedCallback() {

    this.currentCurrency = window.theme.currentCurrency;
    this.currentPerso = false;
    this.currentLang = window.theme.currentLang;

    this._manageShippingTime();
    this._attachListeners();
  }

  _attachListeners() {

    let that = this;

    document.addEventListener('personalize:changed', (event) => {
      that.currentPerso = event.detail.personalize;
      this._manageShippingTime();
    });
  }

  _manageShippingTime() {
    //     Il y a 4 délais de livraison à compter de la date du passage de commande, qui dépendent de la zone et de la commande d’une gravure ou non :
    // - 48h en France et en UE par DHL pour les commandes sans gravure
    // - 15 jours en France et en UE par DHL pour les commandes avec gravure
    // - 6j hors UE par Fedex pour les commandes sans gravure
    // - 20j hors UE par Fedex pour les commandes avec gravure

    const today = new Date();
    let options = { month: 'long', day: 'numeric' };
    let langue = 'en-EN';
    let dateToDisplay;
    let finalDate = new Date(today);
    const allowedCurrencies = ['EUR', 'GBP', 'CHF', 'CAD', 'USD'];
    const currentSubdomain = (window.location.host.split('.').length > 2) ? window.location.host.split('.')[0] : 'com';
    let currentMarket = `${window.theme.currentCurrency}_${currentSubdomain}`;


    if (!allowedCurrencies.includes(window.theme.currentCurrency)) {
      currentMarket = `USD_${currentSubdomain}`;
    }

    let key = `${currentMarket}_noPerso`

    if (this.currentPerso) {
      key = `${currentMarket}_perso`
    }

    finalDate = this._getDateWithWorkingDays(finalDate, window.theme.dateShipping[key]);

    if (this.currentLang === 'fr') {
      langue = 'fr-FR';
    }

    dateToDisplay = finalDate?.toLocaleDateString(langue, options).replace(/\//g, '/');
    document.querySelectorAll('.toDate').forEach(function (value) {
      if (value) {
        value.innerHTML = dateToDisplay;
      }
    })
  }

  _getDateWithWorkingDays(choosenDate, nbDays) {
    let date = choosenDate.getTime(),
      feries = this._getHolidays(choosenDate.getFullYear()),
      i = 1,
      cpt = 0,
      tmp;

    while (cpt < nbDays) {
      tmp = new Date(date + i * 24 * 60 * 60 * 1000);
      let day = tmp.getDay();
      if (day !== 0 && day !== 1) { // weekend
        // jours ferié
        let found = false;
        for (let f = feries.length - 1; f >= 0; f--) {
          if (
            parseInt(feries[f].getDate()) === parseInt(tmp.getDate())
            && parseInt(feries[f].getMonth()) === parseInt(tmp.getMonth())
            && parseInt(feries[f].getFullYear()) === parseInt(tmp.getFullYear())
          ) {
            found = true;
          }
        }
        if (!found) {
          cpt++;
        }
      }
      i++;
    }

    return tmp;
  }

  _getHolidays(an) {
    let JourAn = new Date(an, "00", "01"),
      FeteTravail = new Date(an, "04", "01"),
      Victoire1945 = new Date(an, "04", "08"),
      FeteNationale = new Date(an, "06", "14"),
      Assomption = new Date(an, "07", "15"),
      Toussaint = new Date(an, "10", "01"),
      Armistice = new Date(an, "10", "11"),
      Noel = new Date(an, "11", "25"),
      SaintEtienne = new Date(an, "11", "26"),
      G = an % 19,
      C = Math.floor(an / 100),
      H = (C - Math.floor(C / 4) - Math.floor((8 * C + 13) / 25) + 19 * G + 15) % 30,
      I = H - Math.floor(H / 28) * (1 - Math.floor(H / 28) * Math.floor(29 / (H + 1)) * Math.floor((21 - G) / 11)),
      J = (an * 1 + Math.floor(an / 4) + I + 2 - C + Math.floor(C / 4)) % 7,
      L = I - J,
      MoisPaques = 3 + Math.floor((L + 40) / 44),
      JourPaques = L + 28 - 31 * Math.floor(MoisPaques / 4),
      Paques = new Date(an, MoisPaques - 1, JourPaques),
      VendrediSaint = new Date(an, MoisPaques - 1, JourPaques - 2),
      LundiPaques = new Date(an, MoisPaques - 1, JourPaques + 1),
      Ascension = new Date(an, MoisPaques - 1, JourPaques + 39),
      Pentecote = new Date(an, MoisPaques - 1, JourPaques + 49),
      LundiPentecote = new Date(an, MoisPaques - 1, JourPaques + 50);
    return [JourAn, VendrediSaint, Paques, LundiPaques, FeteTravail, Victoire1945, Ascension, Pentecote, LundiPentecote, FeteNationale, Assomption, Toussaint, Armistice, Noel, SaintEtienne];
  }

  /* (date) {
    return date.toLocaleTimeString('fr-FR', { timeZone: 'Europe/Paris' })
  }*/
}

/* Slider - sticky - video */
export class ProductTopSection extends HTMLDivElement {
  connectedCallback() {

    this.imagesSlider = this.querySelector('.product__images-slider');
    this.video = this.querySelectorAll('.product__video iframe');
    this.groupPopin = this.querySelector('[data-element="group"]');
    this.groupOverlay = this.querySelector('[data-element="group-overlay"]');
    this.zoomOverlay = this.querySelector('.product-zoom-modal-overlay');

    this._attachListeners();
    this._initSticky();
    let that = this

    Pace.on('done', function () {

      if (this.video) {
        this.intersectionObserverVideo = new IntersectionObserver(that._initVideo.bind(that), { rootMargin: '-50px 0px' });
        this.intersectionObserverVideo.observe(that);
      }

      this.intersectionObserverSlider = new IntersectionObserver(that._initSliders.bind(that), { rootMargin: '-50px 0px' });
      this.intersectionObserverSlider.observe(that);
    });

    window.addEventListener("resize", function () {
      that._initSticky();
    });

  }

  _attachListeners() {
    new Delegate(this).on('click', '[data-action="toggle-scroll-images"]', this._toggleScrollImages.bind(this));
    new Delegate(this).on('click', '[data-action="toggle-group"]', this._toggleGroup.bind(this));
    new Delegate(this).on('click', '[data-action="zoom-images"]', this._toggleZoomImages.bind(this));
    new Delegate(this).on('click', '[data-action="close-zoom"]', this._closeZoom.bind(this));
    new Delegate(this).on('click', '[data-action="toggle-informational"]', this._toggleInformal.bind(this));
  }

  _toggleInformal() {

    var that = this;
    setTimeout(function () {
      that._initSticky();
    }, 200);

  }

  /**
   * INIT VIDEO FROM IFRAME
   */

  _initVideo(entries, intersectionObserverVideo) {

    if (!entries[0].isIntersecting) {
      return;
    }

    intersectionObserverVideo.disconnect();

    this.video.forEach(function (value, index) {
      value.setAttribute('src', value.getAttribute('data-src'));
    });

    // hide mobile or desktop video
    let thumbVideoDesktopIndex;
    let thumbVideoMobileIndex;

    let thumbVideoDesktop = this.querySelector('.product__image-nav.product__image-item--video-desktop');
    if (thumbVideoDesktop) thumbVideoDesktopIndex = thumbVideoDesktop.getAttribute('data-index');
    let thumbVideoMobile = this.querySelector('.product__image-nav.product__image-item--video-mobile');
    if (thumbVideoMobile) thumbVideoMobileIndex = thumbVideoMobile.getAttribute('data-index');

    if (window.matchMedia("(max-width: 1023px)").matches) {
      if (thumbVideoMobileIndex > thumbVideoDesktopIndex) {
        thumbVideoMobile.setAttribute('data-index', thumbVideoDesktopIndex)
      }
    } else {
      if (thumbVideoMobileIndex < thumbVideoDesktopIndex) {
        thumbVideoDesktopIndex.setAttribute('data-index', thumbVideoMobileIndex)
      }
    }
  }

  /**
   * SLIDERS
   */

  _initSliders(entries, intersectionObserverSlider) {

    if (!entries[0].isIntersecting) {
      return;
    }

    intersectionObserverSlider.disconnect();

    if (this.imagesSlider) {
      if (typeof window.Swiper === 'undefined') {
        return;
      }

      let wrapper = this.imagesSlider.querySelector('.swiper-wrapper');
      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';

        const slides = Array.from(this.imagesSlider.children).filter(function (child) {
          return child.classList && child.classList.contains('product__image-item');
        });

        slides.forEach(function (slide) {
          slide.classList.add('swiper-slide');
          wrapper.appendChild(slide);
        });

        this.imagesSlider.appendChild(wrapper);
      } else {
        wrapper.querySelectorAll('.product__image-item').forEach(function (slide) {
          slide.classList.add('swiper-slide');
        });
      }

      this.imagesSlider.classList.add('swiper');
      const options = {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 1,
        speed: 500,
        allowTouchMove: true,
        autoplay: false,
        
      };

      var prevButton = this.imagesSlider.parentNode.querySelector('.button--prev');
      var nextButton = this.imagesSlider.parentNode.querySelector('.button--next');
      if (prevButton && nextButton) {
        options.navigation = {
          prevEl: prevButton,
          nextEl: nextButton
        }
      }

      this.mainSlider = new window.Swiper(this.imagesSlider, options);

      let that = this;
      this.mainSlider.on('click', function () {
        if (typeof that.mainSlider.clickedIndex === 'number' && that.mainSlider.clickedIndex >= 0) {
          that._openZoom(that.mainSlider.realIndex);
        }
      });

      this.mainSlider.on('slideChange', function () {
        that._changeNavImageActive(that.mainSlider.realIndex);
      });
    }
  }

  /**
  * PRODUCT IMAGE SCROLL
  */

  _toggleScrollImages(event, target) {
    let index = target.getAttribute('data-index');
    let containerScroll = this.querySelector('.product__images-scroll .product__image-item[data-index="' + index + '"]');

    let container3D = this.querySelector('.product__viewer-icon');
    if (container3D) {
      container3D.classList.remove('active');
    }

    this.querySelectorAll('.product__image-nav').forEach(function (value) {
      value.classList.remove('active');
    })
    target.classList.add('active');

    if (window.matchMedia("(min-width: 1024px)").matches) {
      $('html, body').animate({
        scrollTop: containerScroll.offsetTop + 70
      }, 300);

    } else {
      if (this.mainSlider && typeof this.mainSlider.slideToLoop === 'function') {
        this.mainSlider.slideToLoop(Number(index));
      }
    }
  }

  _changeNavImageActive(index) {
    let imageNav = this.querySelectorAll('.product__image-nav');
    if (!imageNav.length)
      return;

    for (let i = 0; i < imageNav.length; i++) {
      imageNav[i].classList.remove('active');
    }
    imageNav[index].classList.add('active');

    let imagesNav = this.querySelector('.product__images-nav');
    imagesNav.scrollTo({
      top: 0,
      left: imageNav[index].offsetLeft,
      behavior: "smooth"
    });
  }

  /**
  * STICKY
  */

  _initSticky() {


    let stickyWindowHeight = window.innerHeight;
    let stickyNav = this.querySelector('.product__images-nav')
    let stickyImages = this.querySelector('.product__images-container');
    let stickyContent = this.querySelector('.product__content-container');
    let stickyNavHeight = 0;
    let stickyImagesHeight = 0;
    let stickyContentHeight = 0;
    let stickyCss = 0;

    if (stickyNav) {
      stickyNav.classList.remove('stickytop');
      stickyNav.classList.remove('stickybottom');
      stickyNavHeight = stickyNav.offsetHeight;
    }
    if (stickyImages) {
      stickyImages.classList.remove('stickytop');
      stickyImages.classList.remove('stickybottom');
      stickyImagesHeight = stickyImages.offsetHeight;
    }
    if (stickyContent) {
      stickyContent.classList.remove('stickytop');
      stickyContent.classList.remove('stickybottom');
      stickyContentHeight = stickyContent.offsetHeight;
    }
    if (stickyNav) {
      if (stickyNavHeight < stickyWindowHeight) {
        stickyNav.classList.add('stickytop');
      }
    }
    if (stickyImagesHeight < stickyWindowHeight) {
      if (stickyImages) {
        stickyImages.classList.add('stickytop');
      }
    }
    if (stickyContentHeight < stickyWindowHeight) {
      if (stickyContent) {
        stickyContent.classList.add('stickytop');
      }
    }

    if (stickyImagesHeight > stickyContentHeight) {
      if (stickyContentHeight > stickyWindowHeight) {
        if (stickyContent) {
          stickyContent.classList.add('stickybottom');
          stickyCss = stickyWindowHeight - stickyContentHeight - 70;
        }
      }
    } else {
      if (stickyImagesHeight > stickyWindowHeight) {
        if (stickyImages) {
          stickyImages.classList.add('stickybottom');
          stickyCss = stickyImagesHeight - stickyNavHeight - 70;
        }
      }
    }

    this.style.setProperty("--sticky-bottom", "-" + Math.abs(stickyCss) + "px");
  }

  /**
  * Open Group popin
  */

  _toggleGroup(event, target) {
    if (event) event.preventDefault();

    if (this.groupPopin.classList.contains('active')) {
      document.querySelector('body').classList.remove('no-scroll');
      this.groupPopin.classList.remove('active');
      this.groupOverlay.classList.remove('active');
    } else {
      document.querySelector('body').classList.add('no-scroll');
      this.groupPopin.classList.add('active');
      this.groupOverlay.classList.add('active');
    }

  }

  _openZoom(index) {

    // init pinch for mobile
    if (window.matchMedia('screen and (max-width: 1159px)').matches) {
      // get all images
      let images = this.querySelectorAll('.product-zoom-images__image img');
      if (images.length > 0) {
        for (let i = 0; i < images.length; i++) {

          // check if zoom is already initialized
          if (!images[i].parentNode.classList.contains('pinch-zoom-container')) {
            images[i].parentNode.style.height = images[i].offsetHeight + 'px';
            let pz = new PinchZoom(images[i], {
              draggableUnzoomed: false
            });
          }
        }
      }
    }

    // open overlay
    this.zoomOverlay.classList.add('active');

    // scroll to good index
    let imageToScroll = this.querySelector('.product-zoom-images__item');
    if (imageToScroll) {
      let pxToScroll = imageToScroll.clientHeight * index;
      this.querySelector('.product-zoom-images').scroll(0, pxToScroll);
    }
  }

  /**
   * CLOSE ZOOM
   */

  _closeZoom(event, target) {
    // close overlay
    this.zoomOverlay.classList.remove('active');

    this.querySelector('.product-zoom-images').scroll(0, 0);

    // zoom out all images
    const images = Array.from(document.querySelectorAll('.product-zoom-images__item'));
    for (let item of images) {
      if (item.classList.contains('zoomed')) {
        item.classList.remove('zoomed');
      }
      item.children[0].style.transformOrigin = 0;
    }
  }

  /**
  * PRODUCT ZOOM IMAGE SCROLL
  */

  _toggleZoomImages(event, target) {
    let index = target.getAttribute('data-index');
    this._openZoom(index);
  }

}


export class Viewer3d extends HTMLElement {
  connectedCallback() {
    this.viewerWrap = document.querySelector('#viewer')

    if (!this.viewerWrap) {
      return;
    }

    this.imagesContainer = this.querySelector('.product__images-container');
    // Viewer container
    this.viewerContainer = this.querySelector('.product__viewer-container');


    // Custom viewer elements
    this.loading = this.viewerWrap.querySelector('.product__viewer-loading')
    this.zoomWrap = this.viewerWrap.querySelector('.zoom')
    this.zoomInBtn = this.viewerWrap.querySelector('.zoom__in')
    this.zoomOutBtn = this.viewerWrap.querySelector('.zoom__out')
    this.intPrompt = this.viewerWrap.querySelector('.interaction-prompt')


    /**
     * Set to "true" if you want the message to reappear
     * everytime the user stop interacting with the viewer
     */
    this.INTERACTION_PROMPT_ONLY_ONCE = false;

    /**
     * Delay to restart the turntable animation after
     * the last user interaction.
     */
    this.AUTOROTATE_DELAY = 1000;

    /**
     * Speed of the zoom on pressing the button once
     */
    this.ZOOM_CLICK_SPEED = 3;

    /**
     * Speed if we keep pressing the button. It's important to
     * use per-second calcs to have consistent behavior on every
     * device whatever its screen refresh rate (60hz, 144hz...)
     */
    this.ZOOM_PRESS_SPEED_PER_SECOND = 15;

    this.zoomDirection = 0 // 0 for no zoom, 1 for zoom in, -1 for zoom out
    this.zoomTimeout = null
    this.zoomLastTime = null

    let that = this;

    this._attachListeners();

    let topModul3D = this.viewerContainer.offsetTop;
    window.onscroll = function (event) {
      that._toggleSroll(topModul3D)
    }
    // init viewer
    /* Barney.onReady(() => {
       that._initViewer();
     })*/

  }

  destroy() {
    new Delegate(this).destroy();
  }

  _attachListeners() {
    new Delegate(this).on('click', '[data-action="toggle-viewer"]', this._toggleViewer.bind(this));

    // Prevent long touch press from opening the context menu
    this.zoomInBtn.addEventListener('contextmenu', (e) => e.preventDefault())
    this.zoomOutBtn.addEventListener('contextmenu', (e) => e.preventDefault())

    // Listen for mouse and touch press of the buttons
    this.zoomInBtn.addEventListener('pointerdown', (e) => this._onZoomDown(1))
    this.zoomOutBtn.addEventListener('pointerdown', (e) => this._onZoomDown(-1))
    /*let that = this;
    window.addEventListener('scroll', that._toggleSroll());*/

  }

  _toggleSroll(top) {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (window.matchMedia("(min-width: 1024px)").matches) {
      if (scrollTop > top) {
        let that = this;
        this.iframe = this.viewerWrap.querySelector('iframe')
        this.loader = this.viewerWrap.querySelector('.product__viewer-loading');
        this.loader.classList.add('active');
        if (!that.iframe) {
          Barney.onReady(() => {
            this._initViewer();
          })
        }
      }
    }
  }

  _toggleViewer() {
    let that = this;
    this.iframe = this.viewerWrap.querySelector('iframe')
    if (!this.iframe) {
      Barney.onReady(() => {
        that._initViewer();
      })
    }

    if (window.matchMedia("(min-width: 1024px)").matches) {
      this.querySelectorAll('.product__image-nav').forEach(function (value) {
        value.classList.remove('active');
      })
      this.querySelector('.product__viewer-icon').classList.add('active');
      $('html, body').animate({
        scrollTop: this.viewerContainer.offsetTop + 70
      }, 300);

    } else {

      if (this.viewerContainer) {
        this.viewerContainer.classList.toggle('active');
        //this.viewer.zoomIn(-10);
      }

    }
  }

  _initViewer() {

    this.viewer = new Barney.ViewerIframe(this.viewerWrap, {

      // /!\ Not safe for PROD: early access of the viewer API
      //host: 'https://staging-viewer.barney-technologies.com',
      itemId: window.theme.barneyProductID,
      viewerVars: {
        // Enable turntable animation
        'autorotate': true,
        // But change the "restart delay" to 1 second
        'autorotate-delay': this.AUTOROTATE_DELAY,

        // Mouse wheel won't block the scroll and don't show any message
        'mouse': 'cooperative-silent',

        // Don't show the default loading animation
        'loading-style': 'none',

        // Don't show the default "Hold and rotate" message
        'interaction-prompt-style': 'none',

        // Force the language of the viewer
        'lang': 'en',
      }

    })

    this.viewer.one('loadingProgress', (progress) => {
      // First loading progress event (note the 'one()' listener)
      if (this.loading) {
        this.loading.style.display = ''
      }
    })

    this.viewer.on('loadingProgress', (progress) => {
      // Progress is a number between 0 and 1
      // if (this.loading) {
      //   this.loading.innerText = Math.round(progress * 100) + '%'
      // }
    })

    this.viewer.on('ready', () => {
      // All the viewer is ready to render frames

      if (this.loading) {
        this.loading.style.display = 'none'
      }

      this.zoomWrap.style.display = ''

      if (this.intPrompt) {
        this.intPrompt.style.display = ''
        this.intPrompt.innerText = this._isTouch()
          ? "Touch and hold to rotate"
          : "Click and hold to rotate"
      }

      // zoom for large desktop
      if (window.matchMedia("(min-width: 1024px)").matches) {
        if (this.viewerContainer) {
          this.viewer.zoomIn(-5);
        }
      } else {
        if (this.viewerContainer) {
          this.viewer.zoomIn(-10);
        }
      }

    })

    // Depending on the expected user experience
    if (this.INTERACTION_PROMPT_ONLY_ONCE) {
      this.viewer.one('interactionStart', () => {
        if (this.intPrompt) {
          this.intPrompt.style.display = 'none'
        }
      })
    } else {
      this.viewer.on('interactionStart', () => {
        this.viewerWrap.classList.add('hide-elements');
        if (this.intPrompt) {
          this.intPrompt.style.display = 'none'
        }
      })
      this.viewer.on('interactionEnd', () => {
        this.viewerWrap.classList.remove('hide-elements');
        if (this.intPrompt) {
          this.intPrompt.style.display = ''
        }
      })
    }
  }

  _isTouch() {
    return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch
  }


  _onZoomDown(direction) {
    this.zoomDirection = direction

    // Listen for the release of the button
    window.addEventListener('pointerup', this._onZoomUp)
    window.addEventListener('pointercancel', this._onZoomUp)

    // One big zoom in/out on press
    this.viewer.zoomIn(this.ZOOM_CLICK_SPEED * this.zoomDirection)

    // And wait a little before considering the 'button press'
    if (this.zoomTimeout) clearTimeout(this.zoomTimeout)
    this.zoomTimeout = setTimeout(() => this._whileZoomPressed(), 250)
  }

  _onZoomUp(event) {
    // Remove listeners
    window.removeEventListener('pointerup', this._onZoomUp)
    window.removeEventListener('pointercancel', this._onZoomUp)

    // Stop pending timeout
    if (this.zoomTimeout) clearTimeout(this.zoomTimeout)
    this.zoomTimeout = null

    // Reset vars
    this.zoomDirection = 0
    this.zoomLastTime = null
  }

  _whileZoomPressed(time) {
    if (!this.zoomDirection) return

    // Calc the "per second" factor to apply
    if (this.zoomLastTime === null) this.zoomLastTime = time
    const delta = (time - this.zoomLastTime) / 1000
    // If it's a correct number, send it to the viewer
    if (!isNaN(delta)) this.viewer.zoomIn(this.ZOOM_PRESS_SPEED_PER_SECOND * delta * this.zoomDirection)

    // Store value + call next frame
    this.zoomLastTime = time
    requestAnimationFrame(() => this._whileZoomPressed)
  }

}

export class AlmaRea extends HTMLElement {
  connectedCallback() {
    this.almaButton = this.querySelector('.product__reassurance--alma-container');
    if (this.almaButton) {
      this._checkCurrency()
    }
  }

  destroy() {
    new Delegate(this).destroy();
  }

  /**
   * Check If currency is € to display Alma
   */
  _checkCurrency() {
    if (window.theme.currentCurrency === 'EUR') {
      this.almaButton.classList.add('active');
    }
  }

}

export class AlmaPopin extends HTMLElement {
  connectedCallback() {
    this.almaPopin = this.querySelector('[data-element="alma"]');
    this.almaOverlay = this.querySelector('[data-element="alma-overlay"]');

    this._attachListeners();
  }

  destroy() {
    new Delegate(this).destroy();
  }

  _attachListeners() {
    new Delegate(this).on('click', '[data-action="toggle-alma"]', this._toggleAlma.bind(this));
  }

  /**
   * Open Alma popin
   */
  _toggleAlma(event, target) {

    if (event) event.preventDefault();

    if (this.almaPopin.classList.contains('active')) {
      document.querySelector('body').classList.remove('no-scroll');
      this.almaPopin.classList.remove('active');
      this.almaOverlay.classList.remove('active');
    } else {
      document.querySelector('body').classList.add('no-scroll');
      this.almaPopin.classList.add('active');
      this.almaOverlay.classList.add('active');
    }

  }

}

export class BackInStockProduct extends HTMLElement {
  connectedCallback() {
    if (!this) {
      return;
    }
    this.backInStockButton = document.querySelectorAll('[data-action="toggle-back-in-stock"]');
    this.productAvailable = document.querySelectorAll('.product__availablity .product__availablity-available');
    this.productUnavailable = document.querySelectorAll('.product__availablity .product__availablity-unavailable');
    this.productDate = document.querySelectorAll('.product__availablity .product__availablity-date');
    this.backInStockPopin = this.querySelector('[data-element="back-in-stock"]');
    this.backInStockOverlay = this.querySelector('[data-element="back-in-stock-overlay"]');
    this.backInStockSelect = this.querySelector('[data-element="back-in-stock-custom-select"]');
    this.backInStockEmail = this.backInStockPopin.querySelector('#back-in-stock-email');
    this.backInStockSms = this.backInStockPopin.querySelector('#back-in-stock-sms');
    this.backInStockSuccessMessage = this.backInStockPopin.querySelector('#back-in-stock-success-message');
    this.backInStockForm = this.backInStockPopin.querySelector('#back-in-stock-form');
    this.selectedOptionValue = this.backInStockPopin.querySelector('.custom-select__option-selected');

    this._attachListeners();

  }

  destroy() {
    new Delegate(this).destroy();
  }

  _attachListeners() {

    new Delegate(this).on('click', '[data-action="toggle-back-in-stock"]', this._toggleBackInStock.bind(this));
    new Delegate(this).on('change', '[name="back-in-stock-contact"]', this._switchTab.bind(this));
    new Delegate(this).on('click', '[data-action="submit-back-in-stock"]', this._submitBackInStock.bind(this));

    document.addEventListener('variant:changed', (event) => {
      let variant = event.detail.variant;
      this._toggleBackInStockButton(variant)
    });
  }

  /**
   * Enable or disable Back In Stock button based on variant availability
   */
  _toggleBackInStockButton(variant) {

    if (!variant.available) {

      // set title and input name checked when out of stock variant is selected
      this.backInStockSelect.querySelector('.custom-select__option-selected').innerText = variant.option1;
      this.backInStockSelect.querySelector('input[name="back-in-stock-variant"][value="' + variant.option1 + '"]').checked = true;

      this.productDate.forEach(function (el, index) {
        el.classList.add('hidden');
      })
      
      this.backInStockButton.forEach(function (el, index) {
        el.classList.remove('hidden');
      })
      this.selectedOptionValue.innerHTML = variant.option1;
    } else {
      this.productDate.forEach(function (el, index) {
        el.classList.remove('hidden');
      })
      
      this.backInStockButton.forEach(function (el, index) {
        el.classList.add('hidden');
      })
    }

  }


  /**
   * Open Back In Stock popin
   */

  _toggleBackInStock(event, target) {
    if (event) event.preventDefault();

    if (this.backInStockPopin.classList.contains('active')) {
      document.querySelector('body').classList.remove('no-scroll');
      this.backInStockPopin.classList.remove('active');
      this.backInStockOverlay.classList.remove('active');
    } else {
      document.querySelector('body').classList.add('no-scroll');
      this.backInStockPopin.classList.add('active');
      this.backInStockOverlay.classList.add('active');
    }

    this._resetBackInStockFields();
  }


  /**
   * Switch tab
   */

  _switchTab(event, target) {

    this.backInStockPopin.querySelectorAll('[data-tab]').forEach(function (value, index) {

      if (value.getAttribute('data-tab') === target.value) {
        value.classList.add('active')
      } else {
        value.classList.remove('active')
      }

    })

  }


  /**
   * Submit Back In Stock
   */

  _submitBackInStock(event, target) {
    event.preventDefault();

    target.classList.add('is-loading');

    let contact = this.backInStockPopin.querySelector('input[name="back-in-stock-contact"]:checked').value;
    let productID = this.backInStockPopin.querySelector('#back-in-stock-product').value;
    let variantID = this.backInStockPopin.querySelector('input[name="back-in-stock-variant"]:checked').getAttribute('data-variant');

    let that = this;

    if (contact === 'email') {

      BIS.create(this.backInStockEmail.value, variantID, productID).then(function (resp) {

        if (resp.status === 'OK') {

          that._resetBackInStockFields();
          that.backInStockSuccessMessage.classList.remove('hide');
          that.backInStockForm.classList.add('hide');

        } else if (resp.status === 'Error') {
          that.backInStockEmail.classList.add('error');

          // display Back In Stock Error message
          if (resp.errors.email) {
            // error message mail
            that.backInStockEmail.parentElement.querySelector('.error-email').style.display = 'block';
            that.backInStockEmail.parentElement.querySelector('.error-base').style.display = 'none';
          } else {
            // error message base
            that.backInStockEmail.parentElement.querySelector('.error-email').style.display = 'none';
            that.backInStockEmail.parentElement.querySelector('.error-base').style.display = 'block';
          }
        }

        target.classList.remove('is-loading');
      })

    } else if (contact === 'sms') {

      BIS.create(null, variantID, productID, { phone_number: this.backInStockSms.value }).then(function (resp) {

        if (resp.status === 'OK') {

          that._resetBackInStockFields();
          that.backInStockSuccessMessage.classList.remove('hide');
          that.backInStockForm.classList.add('hide');

        } else if (resp.status === 'Error') {

          // display Back In Stock Error message
          that.backInStockSms.classList.add('error');
        }

        target.classList.remove('is-loading');

      })

    }

  }

  /**
   * Reset Back in stock Fields
   */

  _resetBackInStockFields() {
    // reset email field
    this.backInStockEmail.value = '';
    this.backInStockEmail.classList.remove('error');

    // reset sms field
    this.backInStockSms.value = '';
    this.backInStockSms.classList.remove('error');

    // reset success message
    this.backInStockSuccessMessage.classList.add('hide');
    this.backInStockForm.classList.remove('hide');
  }
}

export class BackInStockCustomSelect extends HTMLDivElement {
  connectedCallback(options = {}) {
    this.options = Object.assign({ soldOut: false }, options);

    if (!this) {
      return; // Form element is invalid
    }
    this.selectedOption = this.querySelector('[name="' + this.getAttribute('data-name') + '"]:checked+label');
    this.selectedOptionValue = this.querySelector('.custom-select__option-selected');

    this._attachListeners();
    //this._initSelectValue();
  }

  destroy() {
    new Delegate(this).destroy();
  }

  _attachListeners() {
    new Delegate(this).on('click', '.custom-select__option-selected', this._toggleCustomSelect.bind(this));
    new Delegate(this).on('click', '.custom-select__option label', this._selectOption.bind(this));
  }

  /**
   * Toggle open custom select
   */
  _toggleCustomSelect() {
    if (this.classList.contains('opened')) {
      this.classList.remove('opened');
    } else {
      this.classList.add('opened');
    }
  }

  /**
   * Select option form custom select
   */
  _selectOption(event, target) {
    let value = target.getAttribute('data-value');
    if (window.theme.template === 'product.carte-cadeau') {
      this.selectedOptionValue.innerHTML = target.children[0].outerHTML;
    } else {
      this.selectedOptionValue.innerHTML = value;
    }

    if (this.options['soldOut']) {
      if (value.indexOf(window.theme.sold_out) > -1) {
        this.selectedOptionValue.classList.add('sold-out');
      } else {
        this.selectedOptionValue.classList.remove('sold-out');
      }
    }

    this.selectedOptionValue.removeAttribute('data-clear');

    this.classList.remove('opened');
  }
  /**
   * Set inital value
   */
  _initSelectValue() {
    if (this.selectedOption) {
      this._selectOption('', this.selectedOption);
    }
  }
}

export class AskBuildProduct extends HTMLElement {
  connectedCallback() {
    if (!this) return;

    this.askBuildButton = document.querySelectorAll('[data-action="toggle-ask-build"]');
    this.askBuildPopin = this.querySelector('[data-element="ask-build"]');
    this.askBuildOverlay = this.querySelector('[data-element="ask-build-overlay"]');
    this.askBuildForm = this.askBuildPopin.querySelector('form');
    this.askBuildSuccessMessage = this.askBuildPopin.querySelector('.ask-build__form-message-success');

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("contact_posted")) {
      this._toggleAskBuild(); // Ouvre la popin
      this.askBuildSuccessMessage?.classList.remove("hidden");

      const newUrl = window.location.pathname + window.location.hash;
      window.history.replaceState(null, "", newUrl);
    }

    this._attachListeners();
  }

  destroy() {
    this.askBuildButton.forEach((button) =>
      button.removeEventListener('click', this._toggleAskBuild)
    );
    this.askBuildForm.removeEventListener('submit', this._submitAskBuild);
  }

  _attachListeners() {
    this.askBuildButton.forEach((button) =>
      button.addEventListener('click', this._toggleAskBuild.bind(this))
    );
  }

  _toggleAskBuild(event) {
    if (event) event.preventDefault();

    const isActive = this.askBuildPopin.classList.contains('active');
    document.body.classList.toggle('no-scroll', !isActive);
    this.askBuildPopin.classList.toggle('active', !isActive);
    this.askBuildOverlay.classList.toggle('active', !isActive);

    if (!isActive) this._resetAskBuildFields();
  }

  _resetAskBuildFields() {
    this.askBuildForm.reset();
    this._resetMessages();
  }

  _resetMessages() {
    this.askBuildSuccessMessage.classList.add('hidden');
  }
}


export class ProductTaxe extends HTMLSpanElement {
  connectedCallback() {
    this._manageTaxe()
  }

  destroy() {
    new Delegate(this).destroy();
  }

  /**
   * Check If currency is € to product-taxe
   */
  _manageTaxe() {
    let that = this;
    GIP.getLocalizeData().then(function (data) {
      if (data) {
        // check with With Reach if Currency is EUR.
        if (data.Currency !== 'EUR') {
          if (that) {
            that.classList.remove('hide');
          }
        }
      }
    });
  }

}
try {
  window.customElements.define('product__availablity-date', AvailablityDate, { extends: "span" });
  window.customElements.define('product-section', Viewer3d);
  window.customElements.define('product-top-section', ProductTopSection, { extends: "div" });
  window.customElements.define('rea-section', AlmaRea);
  window.customElements.define('alma-section', AlmaPopin)
  window.customElements.define('back-in-stock-section', BackInStockProduct);
  window.customElements.define('ask-build-section', AskBuildProduct);
  window.customElements.define('custom-select-section', BackInStockCustomSelect, { extends: "div" });
  window.customElements.define('product-taxe', ProductTaxe, { extends: "span" });
} catch (e) { }
